<template>
  <div class="prompt-wrap prompt-wrap-v2">
    <div v-if="insTypeList" class="risk-box">
      <dl class="risk">
        <dd class="bd">
          <p
            v-for="(item, index) in insTypeList"
            :key="index"
          >
            {{ item }}
          </p>
        </dd>
      </dl>
    </div>
    <div class="reminder" />
  </div>
</template>

<script>
  import riskContent from './content'

  export default {
    props: {
      hasInterestDemo: {
        type: Boolean,
        default: false
      },
      // 是否有万能险：由 productGroupList[0].prodOrderList 下 mulInsOrderList 中是否存在 account === true 计算得出
      hasMulInsAccount: {
        type: Boolean,
        default: undefined
      },
      // 是否有分红险：由 initInterest 返回数据中任意一项 bonus 有值计算得出
      hasBonus: {
        type: Boolean,
        default: undefined
      }
    },
    data() {
      return {}
    },
    computed: {
      insTypeList() {
        const { hasInterestDemo, hasMulInsAccount, hasBonus } = this
        return riskContent(
          !!hasInterestDemo,
          !!hasMulInsAccount,
          !!hasBonus
        )
      }
    }
  }
</script>

<style lang="postcss">
  @import 'variable.css';
  .prompt-wrap {
    position: relative;
    @apply --widthcenter;
    color: var(--patch-color-text);
    font-size: 0.26rem;
  }
  .risk-box {
    @apply --box;
    padding: 0.24rem;
    color: var(--primary-color-text);
    .risk {
      background: #f8f8f8;
      padding: 0.3rem 0.3rem 0.1rem;
      border-radius: 6px;;
    }
    .hd {
      font-size: 0.34rem;
      font-weight: bold;
      margin-bottom: 0.16rem;
      text-align: center;
    }
    .bd {
      font-size: 0.3rem;
      padding-left: 0.3rem;
    }
    p {
      position: relative;
      line-height: 1.5;
      margin-bottom: 9px;
      text-align: left;
      &:before {
        content: '';
        position: absolute;
        left: -15px;
        top: 7px;
        font-size: 20px;
        line-height: 1;
        vertical-align: middle;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: var(--theme-primary-color);
      }
    }
  }
</style>
